import useSWR from 'swr';
import { fetchGroupedResults } from '../../../api/series';

export interface UseGroupedResultsProps {
  questionPublicKey: string;
  shouldFetch: boolean;
}

export const useGroupedResults = ({
  questionPublicKey,
  shouldFetch,
}: UseGroupedResultsProps) => {
  const { data, error } = useSWR(
    shouldFetch
      ? `/response-clusterings/for-question/${questionPublicKey}`
      : null,
    async () => {
      const { data } = await fetchGroupedResults(questionPublicKey);
      return data;
    },
  );

  return {
    data,
    error,
  };
};
